export const adminSuccessTable = [
	{
		id: 7898,
		nameOfProduct: "Gbenga Akinnukawe",
		defualtUnit: 4,
		productDiscript: "This is a local breed",
		costItem: 5000.0,
		tbcName: "admin-general-tbody",
		tbcIcon: "styletableicon",
	},
	{
		id: 7898,
		nameOfProduct: "Gbenga Akinnukawe",
		defualtUnit: 4,
		productDiscript: "This is a local breed",
		costItem: 5000.0,
		tbcName: "admin-general-tbody",
		tbcIcon: "styletableicon",
	},
	{
		id: 7898,
		nameOfProduct: "Gbenga Akinnukawe",
		defualtUnit: 4,
		productDiscript: "This is a local breed",
		costItem: 5000.0,
		tbcName: "admin-general-tbody",
		tbcIcon: "styletableicon",
	},
	{
		id: 7898,
		nameOfProduct: "Gbenga Akinnukawe",
		defualtUnit: 4,
		productDiscript: "This is a local breed",
		costItem: 5000.0,
		tbcName: "admin-general-tbody",
		tbcIcon: "styletableicon",
	},
];

export const adminLogistics = [
	{
		id: 1234,
		name: "Godswill Chibuzor",
		account: "1234567890",
		ccv: "123",
		balance: "25000",
		date: "12/10/2022",
		status: "Succesful",
		action: "Notify",
	},
	{
		id: 1234,
		name: "Godswill Chibuzor",
		account: "1234567890",
		ccv: "123",
		balance: "25000",
		date: "12/10/2022",
		status: "Succesful",
		action: "Notify",
	},
	{
		id: 1234,
		name: "Godswill Chibuzor",
		account: "1234567890",
		ccv: "123",
		balance: "25000",
		date: "12/10/2022",
		status: "Succesful",
		action: "Notify",
	},
	{
		id: 1234,
		name: "Godswill Chibuzor",
		account: "1234567890",
		ccv: "123",
		balance: "25000",
		date: "12/10/2022",
		status: "Succesful",
		action: "Notify",
	},
];
